/**
 * Brisk certificates (new, "V2") — the frontend switch. On only when REACT_APP_BRISK_V2_ENABLED is exactly "true".
 *
 * The git-tracked .env keeps it "false" (production builds read .env); it is turned on locally in
 * .env.development.local, which only `npm start` reads (restart it after a change). Off = /briskCreateCertificate is
 * today's page exactly and the "Brisk Certificate List" menu items do not appear. The backend has its own switch
 * (BRISK_V2_ENABLED in the backend .env).
 */
export const isBriskV2Enabled = () =>
  String(process.env.REACT_APP_BRISK_V2_ENABLED || "").trim().toLowerCase() === "true";

export const BRISK_V2_LIST_PATH = "/briskCertificateList";
export const BRISK_V2_CREATE_PATH = "/briskCreateCertificate";
// Brisk money pages (admin only; owner, 2026-10-30). /briskWallet and /briskTransactionHistory are older pages.
export const BRISK_V2_WALLET_PATH = "/briskAgencyWallet";
export const BRISK_V2_HISTORY_PATH = "/briskWalletHistory";
export const BRISK_V2_REPORT_PATH = "/briskTransactionReport";
export const BRISK_V2_MONEY_PATHS = [BRISK_V2_WALLET_PATH, BRISK_V2_HISTORY_PATH, BRISK_V2_REPORT_PATH];
